import BackendApiClient from './BackendApiClient';

export default {
  BackendApiClient,
};
